import {WalletPlatform} from '@/enums/WalletPlatform'
import {isWalletConnectProvider} from '../connection/WalletConnectContext'
import {
  getWalletConnectAddress,
  resolveWalletConnectInvoke,
} from '../connection/WalletConnectConnection'
import {WalletProviderStrategy} from './WalletProviderStrategy'

export class NeonProvider implements WalletProviderStrategy {
  platform = WalletPlatform.NEON
  nep21Name = 'Neon Wallet'

  getAddress(provider: any) {
    if (isWalletConnectProvider(provider)) {
      return getWalletConnectAddress(provider)
    }

    return provider?.account?.address ?? null
  }

  invoke(provider: any, payload: any) {
    if (isWalletConnectProvider(provider)) {
      return resolveWalletConnectInvoke(provider, payload)
    }

    return provider.invoke(payload)
  }
}
